export default __webpack_public_path__ + "static/media/keys.d4ce7ed1.png";